import React from 'react';
import { Link } from 'react-router-dom';

function Programs() {
  return (
    <div className="fade-in">
      <div className="hero">
        <h1>Our Programmes & Initiatives</h1>
        <p>Empowering communities through education, skills development, and social support</p>
      </div>

      <div className="container">
        {/* 1. EDUCATION */}
        <div className="program-card">
          <h3>📚 Education - Academic Tuition</h3>
          <p>
            Education has always been a key focus area for the Foundation. Prior to the COVID-19 pandemic, the Foundation embarked on a widespread drive to ensure that deserving students, especially from the more underprivileged areas, were afforded the opportunity to improve their results or seek assistance in various subjects such as English, Afrikaans, Maths, Accounting and Physics by attending the free tuition programme. This was achieved by students either joining our free online platform or by attending our free contact sessions at many different venues. We were fortunate to secure the services of highly experienced educators, many of whom were subject matter experts, to render the tuition.
          </p>
          <p>
            The COVID-19 pandemic interrupted the programme for a while; however, post-COVID, the tuition was resumed and this saw the relaunch of the free contact sessions at Chatsworth, Phoenix, Tongaat and countrywide on our free online platform. Over the years we have supported hundreds of students from Grade 4 to Grade 12 in achieving their academic goals, and we continue to maintain a presence at a local children's home in Chatsworth. The Foundation is currently investigating other alternative mechanisms that will enhance this programme.
          </p>
        </div>

        <div className="program-card">
          <h3>👶 Early Childhood Development (ECD)</h3>
          <p>
            The Foundation's first ECD centre was opened at our head office in Chatsworth in 2024. We have proudly attained accreditation from the Department of Education. The ECD centre is well equipped with the latest resources in the ECD teaching and learning space. This facility is playing a significant role in grooming young minds, as we offer both academic and extra-curricular sporting activities. Children attending our Preschool are also provided with nutritious meals, as we believe that a full tummy ensures an enjoyable learning experience. Similar ECD centres are planned for other areas.
          </p>
        </div>

        <div className="program-card">
          <h3>🎓 Interest Free Student Loans at Tertiary Level</h3>
          <p>
            The Foundation provides assistance (funding) to extremely disadvantaged students to pursue their career after Matric, in the form of an interest-free loan. Access to this service is via an application and is subject to terms and conditions.
          </p>
          <p>
            Set criteria are applied in determining whether to grant the assistance. These include the applicant's financial circumstances, academic performance and the chosen qualification route. Applicants must be willing to sign a contract.
          </p>
          {/* TODO: pop-up application form - awaiting content from client */}
        </div>

        {/* 2. SKILLS DEVELOPMENT */}
        <div className="program-card">
          <h3>🔧 Skills Development</h3>
          <p>
            This programme targets youth (over 18) and unemployed members of the community. Over the past few years, the Foundation has been providing the youth and the unemployed with free skills development in Basic Plumbing, Basic Electrical and Sewing classes. We engage the services of qualified people and run courses which empower disadvantaged people with a new skill, providing them with sufficient information and knowledge so that they may become employable or start something on their own, thereby enabling them to sustain their livelihoods.
          </p>
          <p>
            Over the years, people attending these skills development classes have progressed to becoming self-employed, and some have achieved gainful employment. The Foundation is exploring other innovative solutions to enhance this programme.
          </p>
        </div>

        {/* 3. YOUTH DEVELOPMENT */}
        <div className="program-card">
          <h3>👥 Youth Development / Activities</h3>
          <p>
            The Shantik Foundation Youth Group is a dynamic collective of young individuals aged 13-35, united in their pursuit of self-discovery and personal growth. Gathering every Friday from 16h30, they embark on a holistic journey, nurturing their spiritual, physical and mental well-being.
          </p>
          <p>
            Under the guidance of experienced mentors, participants explore ancient scriptures and philosophies, cultivating a deeper understanding of their heritage. The group also engages in invigorating sports and physical activities, promoting physical fitness and teamwork. As they unwind, our youth stimulate their mental faculties through engaging debates, creative expression and public speaking exercises.
          </p>
          <p>
            This inclusive environment fosters growth, friendship and a profound connection with their cultural roots. Notably, the youth group is committed to giving back to the community, volunteering their time on various outreach projects in collaboration with other like-minded organisations.
          </p>
          <p>
            If you would like to know more about the Shantik Foundation Youth Group or would like to join, please <Link to="/contact" className="mission-link">contact us here</Link>.
          </p>
        </div>

        {/* 4. RELIGIOUS / SPIRITUAL UPLIFTMENT */}
        <div className="program-card">
          <h3>🙏 Religious / Spiritual Upliftment - Sathsangh</h3>
          <p>
            The Foundation conducts a Sathsangh service (religious) every Sunday morning from 08h30 to 09h30, which is open to all members of our community and has attracted many people from all walks of life. Our congregation is steadily growing, and we also have some families who require our assistance with other social welfare matters.
          </p>
          <p>
            Apart from the spiritual feast that is presented, everyone attending the religious service on a Sunday is provided with a nutritious meal. Our organisation believes that service to humanity is service to God!
          </p>
          <p>
            Religious events are observed, and some are celebrated with much festive fun and excitement, with young and old participating with great enthusiasm. <strong>Praying together is staying together.</strong>
          </p>
        </div>

        <div className="program-card">
          <h3>✨ Children's Spiritual Upliftment</h3>
          <p>
            Every Sunday morning, the younger ones join our classes focussing on Education in Human Values, offering academic and holistic learning that helps children grow into well-rounded individuals. A combination of spirituality, character development and values-based education is taught.
          </p>
          <p>
            Lessons encompass the five human values (Truth, Righteousness, Peace, Love and Non-violence) through activities, stories and service.
          </p>
          <p>
            Annually, we also host the Heritage Camp in partnership with another religious body. At the day camp, young children and youth play indigenous games, learn some basic yoga, participate in quizzes and learn the art of teamwork.
          </p>
        </div>

        <div className="program-card">
          <h3>🧘 Yoga</h3>
          <p>
            Yoga was developed as a spiritual practice thousands of years ago. It is a practice that connects the body, breath and mind, using physical postures, breathing exercises and meditation to improve overall health.
          </p>
          <p>
            Yoga classes are held every Tuesday morning from 09h00 to 10h00 and are attended by ladies from within our community. Classes are conducted by a qualified Yoga practitioner and are well attended.
          </p>
        </div>

        {/* 5. POVERTY ALLEVIATION */}
        <div className="program-card">
          <h3>💼 Poverty Alleviation</h3>
          <p>
            The Foundation is continuously pursuing innovative concepts to help disadvantaged and unemployed individuals become self-sustainable. One such concept is providing seed capital to budding entrepreneurs who want to start a home-based business.
          </p>
          <p>
            We have access to experienced business people and suitably qualified individuals who are prepared to assist and share their knowledge on how to successfully run and operate a business. Recipients are then taken under the Foundation's mentorship programme and provided with the necessary support. This opportunity is open to community members who have a solid business plan and is subject to terms and conditions.
          </p>
          <p>
            Support is offered to destitute individuals and families by providing them with pre-loved clothing and shoes that have been donated to the Foundation. Where possible, meals are also provided by the Foundation; however, for daily hot, nutritious meals, people are referred to some of our other affiliated organisations, ensuring that no man, woman or child goes hungry.
          </p>
        </div>

        {/* 6. COMMUNITY HELPLINE */}
        <div className="program-card">
          <h3>☎️ Toll Free Community Helpline</h3>
          <p><strong>Call:</strong> <a href="tel:080014557">0800 14557</a></p>
          <p>
            People who are experiencing challenges and are seeking spiritual guidance or assistance with matters that require counselling are welcome to call our toll-free number. There will always be a caring person to listen to you, and they will endeavour to provide the necessary support that may be required.
          </p>
        </div>

        {/* 7. OTHER EVENTS */}
        <div className="program-card">
          <h3>🎉 Other Events - Women's Day</h3>
          <p>
            The Foundation has hosted three very successful Women's Day events in commemoration of National Women's Day in August. These have become the highlight of the calendar for the ladies. The programmes have been designed to enrich mind, body and soul, and include empowering talks, dance moves, fun and games, and lovely prizes and goodie bags for all attendees.
          </p>
          <p>
            The programme is tailored to allow the mothers and sisters to relax, share encouraging stories (personal testimonies) and simply feel special. It is also an opportunity to recognise the efforts made and show gratitude.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Programs;
